// Typelizer digest 7195f1c38b2bbe5d0701a9323f30b491
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /learners/schools/:school_id/relief_listings/invitations */
  create: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/schools/:school_id/relief_listings/invitations', params, options),
    method: 'post',
  }),

  /** GET /learners/schools/:school_id/relief_listings/invitations/new */
  new: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/relief_listings/invitations/new', params, options),
    method: 'get',
  }),

  /** GET /learners/relief_listings/invitations/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/relief_listings/invitations/:id', params, options),
    method: 'get',
  }),

  /** PATCH /learners/relief_listings/invitations/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/learners/relief_listings/invitations/:id', params, options),
    method: 'patch',
  }),
}
